
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Category } from "./promptTypes";

/**
 * Fetches all active categories
 */
export const getCategories = async (): Promise<Category[]> => {
  try {
    const { data, error } = await supabase
      .from('categories')
      .select('id, name, slug, description, icon, parent_id, keywords')
      .eq('is_archived', false)
      .order('name');

    if (error) throw error;

    return data || [];
  } catch (error: any) {
    console.error('Error fetching categories:', error);
    toast.error('Failed to load categories');
    return [];
  }
};
